import React from 'react';
import draftToHtml from 'draftjs-to-html';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { getCorruptRTEStatePlaceholder } from 'shared/lib/rteHelper';
import CollabAvatarWrapper from 'main/components/show/cuesheet/collabAvatarWrapper';
import { Avatar as UserAvatar } from '@shoflo-rundown/polymer.legacy';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

/**
 * Read Only RTE Cell
 */
class RTEReadOnly extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate =
      PureRenderMixin.shouldComponentUpdate.bind(this);
  }

  render() {
    const { rteState, customColors, placeholder, removeLinks, collabCell } =
      this.props;

    const avatarNode = collabCell ? (
      <CollabAvatarWrapper>
        <UserAvatar user={collabCell.get('user').toJS()} />
      </CollabAvatarWrapper>
    ) : null;

    //No need to render if there is no state...
    if (!rteState) {
      return (
        <div style={{ display: 'inline-block' }}>
          {placeholder}
          {avatarNode}
        </div>
      );
    }

    const rawRTEState = rteState.toJS ? rteState.toJS() : rteState;
    let markup = '<span></span>';

    /**
     * Try to generate html based on current rteState. If TypeError happens
     * during the process then use the default corrupted rteState.
     */
    try {
      markup = draftToHtml(rawRTEState, false, false, false, customColors);
    } catch (e) {
      markup = draftToHtml(
        getCorruptRTEStatePlaceholder(),
        false,
        false,
        false,
        customColors,
      );
    }

    if (removeLinks && markup.includes('<a')) {
      //remove opening a tags without removing nested elements
      markup = markup.replace(
        /<a(.*)target="_blank">|<a(.*)target="_blank" >/g,
        '<span style="text-decoration: underline;">',
      );
      //remove closing a tags
      markup = markup.replace(/<\/a>/g, '</span>');
    }

    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: markup }} />
        {avatarNode}
      </div>
    );
  }
}

const stringOrObj = React.PropTypes.oneOfType([
  React.PropTypes.object,
  React.PropTypes.string,
]);

RTEReadOnly.propTypes = {
  rteState: stringOrObj,
  customColors: React.PropTypes.object.isRequired,
  placeholder: stringOrObj,
};

export default RTEReadOnly;
